import {
    SET_ENROLL_WORKFLOW,
    UPDATE_STEP,
    SET_ORCHESTRATOR_INSTANCE_ID,
    SET_ACTIVE_STEP,
    SET_ACTIVE_STEP_DATA,
    SET_INITIAL_STATE,
    SET_ENROLL_CACHE,
    CLEAR_SECRET_ACTIVE_STEP_DATA,
    ISetEnrollCache,
    ISetActiveStep,
    EnrollWorkflow,
    ISetActiveStepData,
    ISetEnrollTenant,
    IUpdateStepStatus,
    ISetOrchestratorInstanceId,
    EnrollStep,
    EnrollCache,
    ISetInitialState,
    IClearSecretActiveStepData,
    ErpIntegrationData,
} from "./enroll-tenant-types";

export const setEnrollTenant = (
    enrollTenant: EnrollWorkflow | null
): ISetEnrollTenant => ({
    type: SET_ENROLL_WORKFLOW,
    enrollTenant,
});

export const clearWorkflowData = (): ISetInitialState => ({
    type: SET_INITIAL_STATE,
});

export const setActiveStep = (
    activeStep: EnrollStep | null
): ISetActiveStep => ({
    type: SET_ACTIVE_STEP,
    activeStep,
});

export const setEnrollCache = (enrollCache: EnrollCache): ISetEnrollCache => ({
    type: SET_ENROLL_CACHE,
    enrollCache,
});

export const setActiveStepData = (data: string | null): ISetActiveStepData => ({
    type: SET_ACTIVE_STEP_DATA,
    data,
});

export const clearSecretActiveStepData = (
    data: ErpIntegrationData
): IClearSecretActiveStepData => ({
    type: CLEAR_SECRET_ACTIVE_STEP_DATA,
    data,
});

export const updateStep = (step: EnrollStep): IUpdateStepStatus => ({
    type: UPDATE_STEP,
    step: step,
});

export const setOrchestratorInstanceId = (
    orchestratorInstanceId: string | null
): ISetOrchestratorInstanceId => ({
    type: SET_ORCHESTRATOR_INSTANCE_ID,
    orchestratorInstanceId,
});
